import { logger } from '@/utils/logger';
import { useEffect, useState } from 'react';
import { ButtonLink } from '@/components/ButtonLink';
import type { StickyFooterBannerFragment } from '@/utils/dato/generated';

const StickyFooterBanner = ({
  additionalUrlParameters,
  linkApplyButton,
  buttonText,
}: StickyFooterBannerFragment & { campaign?: string }) => {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!window.AF_SMART_SCRIPT) {
      return;
    }

    const appsFlyerOptions = linkApplyButton as GenerateOneLinkURLArguments;

    if (!appsFlyerOptions?.oneLinkURL) {
      logger.error({
        message: 'Provided sticky button options object is invalid',
        page: window.location.href,
        id: 'apps-store-buttons',
        appsFlyerOptions,
      });
      return;
    }

    const link = window.AF_SMART_SCRIPT.generateOneLinkURL(linkApplyButton as GenerateOneLinkURLArguments);

    if (link) {
      const url = new URL(link.clickURL);

      const urlParams = new URLSearchParams(url.search);

      additionalUrlParameters.forEach((param) => {
        urlParams.append(param.key, param.value || '');
      });

      url.search = `?${urlParams.toString()}`;

      setUrl(url.toString());
    }
  }, [linkApplyButton, additionalUrlParameters]);

  return (
    <div className="p-3 block md:hidden fixed bg-background w-full bottom-0 z-10">
      <ButtonLink className="w-full" href={url || ''}>
        {buttonText}
      </ButtonLink>
    </div>
  );
};

export default StickyFooterBanner;
